/* Soft navigation: swap page content in place so the radio keeps playing across pages.
   Falls back to normal navigation on anything it can't handle. */
(function () {
  'use strict';
  if (!window.history || !window.fetch) return;
  // never soft-navigate inside the Shopify theme editor: it must see real page loads to know which template you're editing
  if ((window.Shopify && window.Shopify.designMode) || window.self !== window.top) return;

  var SWAP = '#ic3y-page';
  var busy = false;

  function sameOrigin(url) {
    try { var u = new URL(url, location.href); return u.origin === location.origin; }
    catch (e) { return false; }
  }

  function eligible(a) {
    if (!a || !a.href) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download') || a.dataset.noPjax !== undefined) return false;
    if (!sameOrigin(a.href)) return false;
    var u = new URL(a.href, location.href);
    if (u.pathname === location.pathname && u.hash) return false;   // in-page anchor
    // checkout, account and admin must be real navigations
    if (/^\/(checkout|account|admin|cart\/)/.test(u.pathname)) return false;
    if (u.pathname.indexOf('/cart') === 0) return false;
    if (a.hasAttribute('data-no-pjax') || /[?&]rate=/.test(u.search)) return false;   // album score deep links: full load
    return true;
  }

  function setBusy(on) {
    var el = document.querySelector(SWAP);
    if (el) el.style.opacity = on ? '0.45' : '';
  }

  function go(url, push) {
    if (busy) return;
    busy = true;
    setBusy(true);
    fetch(url, { headers: { 'X-Requested-With': 'ic3y-pjax' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(SWAP);
        var here = document.querySelector(SWAP);
        if (!fresh || !here) { location.href = url; return; }

        here.replaceWith(fresh);
        document.title = doc.title;
        document.body.className = doc.body.className;

        // per-section stylesheets and inline <style> blocks arrive with the markup;
        // section scripts are re-run by bootPage below.
        if (push) history.pushState({ ic3y: true }, '', url);
        window.scrollTo(0, 0);
        if (window.IC3Y_bootPage) window.IC3Y_bootPage();
        if (window.IC3Y_bootSeats) window.IC3Y_bootSeats();
        if (window.IC3Y_deepRate) setTimeout(window.IC3Y_deepRate, 60);
        // section <script src> tags don't run when swapped in — load any new ones
        fresh.querySelectorAll('script[src]').forEach(function (old) {
          var src = old.getAttribute('src');
          if (document.querySelector('head script[src="' + src + '"], script[data-ic3y-loaded="' + src + '"]')) return;
          var s = document.createElement('script');
          s.src = src; s.setAttribute('data-ic3y-loaded', src);
          document.body.appendChild(s);
        });
        // inline section scripts (past-events tabs, etc.) don't run when swapped in — re-run them
        fresh.querySelectorAll('script:not([src])').forEach(function (old) {
          var t = (old.getAttribute('type') || '').toLowerCase();
          if (t && t !== 'text/javascript' && t !== 'module') return;
          var s = document.createElement('script');
          if (t) s.type = t;
          s.textContent = old.textContent;
          old.replaceWith(s);
        });
        if (window.IC3Y_bootArchive) window.IC3Y_bootArchive();
        setBusy(false);
      })
      .catch(function () { location.href = url; })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var a = e.target.closest && e.target.closest('a');
    if (!eligible(a)) return;
    e.preventDefault();
    go(a.href, true);
  });

  addEventListener('popstate', function (e) {
    if (e.state && e.state.ic3y) go(location.href, false);
  });

  history.replaceState({ ic3y: true }, '', location.href);
})();
